import React, { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Check for saved token and user info in localStorage
    const token = localStorage.getItem('token');
    const userInfo = localStorage.getItem('user');
    
    if (token && userInfo) {
      try {
        const user = JSON.parse(userInfo);
        setCurrentUser({
          ...user,
          token
        });
      } catch (e) {
        // Invalid stored data
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
    
    setLoading(false);
  }, []);

  // Save user data after login
  const setUserData = (userData, token) => {
    console.log('Setting user data:', userData);
    // Handle verification status with multiple property name possibilities
    const isVerified = userData.is_verified || userData.isVerified || userData.verified || false;
    
    const user = {
      id: userData.user_id || userData.id,
      email: userData.email,
      // Store verification status with both property names for compatibility
      is_verified: isVerified,
      isVerified: isVerified,
      role: userData.role,
      first_name: userData.first_name || userData.firstName || '',
      last_name: userData.last_name || userData.lastName || '',
      firstName: userData.first_name || userData.firstName || '',
      lastName: userData.last_name || userData.lastName || ''
    };
    
    console.log('Processed user data:', user);
    
    // Store in localStorage for persistence
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    
    // Update state
    setCurrentUser({
      ...user,
      token
    });
  };

  // Update verification status
  const updateVerificationStatus = (isVerified) => {
    if (!currentUser) return;
    
    const updatedUser = {
      ...currentUser,
      is_verified: isVerified,
      isVerified: isVerified
    };
    
    localStorage.setItem('user', JSON.stringify(updatedUser));
    setCurrentUser(updatedUser);
  };

  // Clear user data on logout
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setCurrentUser(null);
  };

  const value = {
    currentUser,
    setUserData,
    updateVerificationStatus,
    logout,
    loading,
    error,
    setError
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
} 